import { render, staticRenderFns } from "./excelalert.vue?vue&type=template&id=70244f0f"
import script from "./excelalert.vue?vue&type=script&lang=js"
export * from "./excelalert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports